import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";

import { expired } from "../../../../utils/date";
import {
  DATETIME,
  TIME,
  VERBOSE_DATETIME_ORDINAL
} from "../../../../utils/dateFormats";


const RequestedBy = ({ request, userHoursThisWeek, shiftHours }) => (
  <tr>
    <th>Requested By</th>
    <td>
      {request.user ? (
        <a href={`/users/${request.user_id}`} className="styled-link">
          {[request.user.first_name, request.user.last_name].join(", ")}
        </a>
      ) : (
        <span>
          EMPLOYEE NOT FOUND
        </span>
      )}
      &nbsp;
      {!request.active && !request.processed ? (
        <span className="grey-text">
          <i className="glyphicon glyphicon-time" /> {userHoursThisWeek} Hours&nbsp;
          <i className="glyphicon glyphicon-arrow-right" />&nbsp;
          <i className="glyphicon glyphicon-time" />&nbsp;
          {userHoursThisWeek - shiftHours} Hours
        </span>
      ) : null}
    </td>
  </tr>
);

const Shift = ({ request, shiftHours }) => (
  <tr>
    <th>Shift</th>
    <td
      className={classNames({
        "pink-text": expired(request.shift.start_time) && !request.processed
      })}
    >
      {moment(request.shift.start_time).format(VERBOSE_DATETIME_ORDINAL)} -{" "}
      {moment(request.shift.end_time).format(TIME)}
      <span className="grey-text">&nbsp;({shiftHours} Hours)</span>
    </td>
  </tr>
);

const Information = ({ request, shiftHours, userHoursThisWeek }) => [
  <tr key="location">
    <th>Location</th>
    <td>{request.locationName}</td>
  </tr>,
  <tr key="position">
    <th>Position</th>
    <td>{request.positionName}</td>
  </tr>,
  <Shift key="shift" request={request} shiftHours={shiftHours} />,
  <tr key="reason">
    <th>Reason</th>
    <td>{request.reason ? request.reason : "None specified by Employee"}</td>
  </tr>,
  <RequestedBy
    key="requestedBy"
    request={request}
    userHoursThisWeek={userHoursThisWeek}
    shiftHours={shiftHours}
  />,
  <tr key="requestedOn">
    <th>Requested On</th>
    <td>{moment(request.created_at).format(DATETIME)}</td>
  </tr>
];


RequestedBy.propTypes = {
  request: PropTypes.object.isRequired,
  shiftHours: PropTypes.number,
  userHoursThisWeek: PropTypes.number
};

Shift.propTypes = {
  request: PropTypes.object.isRequired,
  shiftHours: PropTypes.number
};

Information.propTypes = {
  request: PropTypes.object.isRequired,
  shiftHours: PropTypes.number,
  userHoursThisWeek: PropTypes.number
};

RequestedBy.defaultProps = {
  shiftHours: 0,
  userHoursThisWeek: 0
};

Shift.defaultProps = {
  shiftHours: 0
};

Information.defaultProps = {
  shiftHours: 0,
  userHoursThisWeek: 0
};

export default Information;
